import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { actions } from 'services/store/ai';
import {
  FormulaField,
  FormulaFields,
  FormulaFieldValue,
} from 'services/store/ai/types';
import { ControlComponent } from './types';
import { DurationSelectorContainer as DurationSelector } from './components/DurationSelector';
import { BpmSelectorContainer as BpmSelector } from './components/BpmSelector';
import EnergySelector from './components/EnergySelector';
import GenreBlendSelector from './components/GenreBlendSelector';
import InstrumentsSelector from './components/InstrumentsSelector';
import KeySelector from './components/KeySelector';
import StructureSelector from './components/StructureSelector';
import UserLoopSelector from './components/UserLoopSelector';

type FormulaItemComponents = {
  [FieldName in FormulaField['field']]: ControlComponent<
    Extract<FormulaField, { field: FieldName }>['value']
  >;
};

const components: FormulaItemComponents = {
  [FormulaFields.Duration]: DurationSelector,
  [FormulaFields.Instruments]: InstrumentsSelector,
  [FormulaFields.GenreBlend]: GenreBlendSelector,
  [FormulaFields.Energy]: EnergySelector,
  [FormulaFields.Structure]: StructureSelector,
  [FormulaFields.Bpm]: BpmSelector,
  [FormulaFields.Key]: KeySelector,
  [FormulaFields.UserLoop]: UserLoopSelector,
};

interface FormulaItemProps {
  field: FormulaField;
}

const FormulaItem = ({ field: { field, value } }: FormulaItemProps) => {
  const dispatch = useDispatch();

  const component = components[field];

  const handleChange = useCallback(
    (newValue: FormulaFieldValue) =>
      dispatch(
        actions.setFormulaFieldValue({
          field,
          value: newValue,
        })
      ),
    [dispatch, field]
  );

  if (!component) {
    return null;
  }

  return (
    <Box component={components[field]} value={value} onChange={handleChange} />
  );
};

export default FormulaItem;
